import { ButtonWithIcon as Button } from 'src/components/ButtonWithIcon/ButtonWithIcon';
import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

//GridHeader start
export const GridHeaderRow = styled('div', { label: 'GridHeaderRow' })`
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 3fr 3fr;
    color: ${mainColors.main.primary};
    font-size: 10px;
    font-weight: bold;
    height: 32px;
`;

export const GridItem = styled('div', { label: 'GridItem' })`
    display: grid;
    margin: auto 8px;
`;

export const GridBody = styled('div', { label: 'GridBody' })`
    height: calc(100vh - 56px - 47px - 100px - 40px);
    overflow: auto;
    padding-bottom: 40px;
`;
//GridHeader end


//GridBodyRow start
export const GridBodyRow = styled('div', { label: 'GridBodyRow' }) <{ isProcessed?: boolean }>`
    opacity:  ${({ isProcessed }): number => isProcessed === true ? 0.4 : 1};
    pointer-events: ${({ isProcessed }): string => isProcessed === true ? 'none' : 'auto' };
    padding-bottom: 8px;

    &:nth-of-type(odd) {
        background: ${mainColors.grays.gray100};
        margin: 8px 0;
    }
    &:nth-of-type(even) {
        background: ${mainColors.default.light};
    }
`;

export const GridRow = styled('div', { label: 'GridRow' })`
    grid-template-columns: 2fr 2fr 2fr 3fr 3fr;
    grid-template-rows: 40px 40px;

    display: grid;
    font-size: 12px;
`;

export const GridItemRow = styled('div', { label: 'GridItemRow' })`
    margin: auto 4px auto 4px;
`;


export const SmallerItemRow = styled(GridItemRow, { label: 'SmallerItemRow' })`
    direction: rtl;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const GridItemDropDown = styled(GridItemRow, { label: 'GridItemDropDown' })`
    display: flex;
`;

export const ItemNotes = styled(GridItemRow, { label: 'ItemNotes' })`
    grid-column-start: 2;
    grid-column-end: end;
    grid-row-start: 2;
    grid-row-end: 3;

    display: flex;
    margin: auto 8px auto 4px;
`;

export const ButtonWrapper = styled(Button, { label: 'ButtonWrapper' })`
    margin-left: 8px;
`;

//GridBodyRow end
